import axios, { type AxiosInstance } from 'axios';
import router from '@/router';

export const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const locale = localStorage.getItem('locale') || 'ar';
  config.headers['Accept-Language'] = locale;

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Lazy import to avoid a circular dependency (auth store imports this file).
      const { useAuthStore } = await import('@/stores/auth');
      // logout() clears both localStorage AND the Pinia refs — required so the
      // guestOnly guard on /login lets the user through instead of bouncing
      // them back to the dashboard.
      useAuthStore().logout();
      if (router.currentRoute.value.name !== 'Login') {
        const redirect = router.currentRoute.value.fullPath;
        void router.push({ name: 'Login', query: { redirect } });
      }
    }
    if (error.response?.status === 403 &&
        error.response?.data?.errors?.code === 'ENGINEER_ACCREDITATION_REQUIRED') {
      const { useAuthStore } = await import('@/stores/auth');
      useAuthStore().accreditationMissing = true;
      useAuthStore().accreditationDialogVisible = true;
    }
    return Promise.reject(error);
  },
);

export interface ApiResponse<T = unknown> {
  status: boolean;
  status_code: number;
  message: string;
  data: T;
  errors?: Record<string, string[]>;
}
